import { VerticalContainer } from '@american-autonomy/rantizo-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ItemCardWithBorder: FunctionComponent<Props> = ({
    children,
    className = '',
    onClick,
    testId = TEST_ID
}) => (
    <VerticalContainer
        className={`${styles.itemCardWithBorder} ${className}`}
        onClick={onClick}
        testId={testId}
    >
        {children}
    </VerticalContainer>
);

export default ItemCardWithBorder;
